import { render, staticRenderFns } from "./OrgSelect.vue?vue&type=template&id=1f452e1f&scoped=true"
import script from "./OrgSelect.vue?vue&type=script&lang=js"
export * from "./OrgSelect.vue?vue&type=script&lang=js"
import style0 from "./OrgSelect.vue?vue&type=style&index=0&id=1f452e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f452e1f",
  null
  
)

export default component.exports